import { Chip as MuiChip, type ChipProps as MuiChipProps } from "@mui/material";
import { forwardRef } from "react";

export type ChipVariant = "assist" | "filter" | "input" | "suggestion";

export type ChipProps = Omit<MuiChipProps, "variant" | "color"> & {
  variant?: ChipVariant;
  selected?: boolean;
  // TODO - type properly
  href?: string;
};

export const Chip = forwardRef<HTMLDivElement, ChipProps>((props, ref) => {
  const { variant = "assist", selected, className, ...rest } = props;
  return (
    <MuiChip
      ref={ref}
      className={`${className || ""} MuiChip-${variant} ${selected ? "Mui-selected" : ""}`}
      {...rest}
    />
  );
});
